import { createReducer, on } from '@ngrx/store';
import { Settings } from '../../models/settings.model';
import { settingsActions } from './settings.actions';

export const initialState: Settings|Object = {};

export const settingsReducer = createReducer(
    initialState,
    on(settingsActions.getSettingsSuccess, (state, {payload}) => payload)
)